<template>
  <div class="shops-show">
    <header-component></header-component>
    <md-layout md-align="center">
      <md-snackbar md-position='top center' ref='error'>
        <span>{{snackbarMsg}}</span>
      </md-snackbar>
      <md-layout class="shop-card" md-tag="md-card" md-column md-flex="90">
        <md-card-content>
          <p class="shop-name">{{ shop.name }}</p>
          <p v-if="shop.comments">
            <md-icon class="md-chat_bubble_outline">chat_bubble_outline</md-icon>
            Sakenoteユーザーからの推薦の言葉
          </p>
          <p class="shops-show-shop-comment" v-for="comment in shop.comments" :key="comment.id">
            {{ comment.content }}
          </p>
          <table>
          　<tr>
          　　<td width="30%"><md-icon class="location_on">location_on</md-icon>場所</td>
          　　<td width="70%">{{ shop.place }}</td>
          　</tr>
          　<tr>
          　　<td><md-icon class="md-train">train</md-icon>最寄駅</td>
          　　<td>{{ shop.station }}</td>
          　</tr>
            <tr>
          　　<td><md-icon class="md-web">web</md-icon>ホームページ</td>
          　　<td><a v-bind:href="shop.tabelog_or_gurunavi_url" target="_blank">{{ shop.tabelog_or_gurunavi_url }}</a></td>
          　</tr>
            <tr>
          　　<td><md-icon class="md-map">map</md-icon>住所</td>
          　　<td>{{ shop.address }}</td>
          　</tr>
          </table>
          <p><goole-map :locationData="shop.location"></goole-map>※住所情報から地図を表示しているため、正しい位置ではない場合がございます。正しい位置は予約サイト等でご確認ください。</p>
          <p>
            <md-icon class="md-edit">edit</md-icon>
            <a href="#comment-box" v-on:click="showCommentBox">オススメコメントを書く</a>
          </p>
          <form novalidate @submit.stop.prevent="onSubmit" v-bind:class="{ hidden: isHidden }">
            <md-input-container v-bind:class="{ 'md-input-invalid': hasError }">
              <md-icon class="md-chat_bubble_outline">chat_bubble_outline</md-icon>
              <label>オススメポイント</label>
              <md-input required id="comment-box" class="f-txt" v-model="comment"></md-input>
            </md-input-container>
            <md-button type="submit" class="md-raised md-primary md-dense">送信</md-button>
          </form>
        </md-card-content>
      </md-layout>
    </md-layout>
    <md-layout md-align="center">
      <md-layout md-flex="90">
        <router-link class="shops-show-back" :to="{ name: 'ShopsIndex' }"><i class="el-icon-caret-left"></i>戻る</router-link>
      </md-layout>
    </md-layout>
  </div>
</template>

<script>
import HeaderComponent from '../Header.vue'
import GooleMap from './GoogleMap'
import firebase from 'firebase'
import firebaseApp from '../../firebaseApp'
import router from '../../router/index'
const db = firebaseApp.firestore()
const commentRequestRef = db.collection('comment_requests')

let data = {
  shop: {comments: [{content: ''}]},
  isHidden: true,
  comment: '',
  hasError: false,
  snackbarMsg: ''
}

export default {
  name: 'shops-show',
  data: function () {
    return data
  },
  components: {
    HeaderComponent,
    GooleMap
  },
  methods: {
    showCommentBox: function () {
      data.isHidden = false
    },
    onSubmit: function () {
      if (this.isValid) {
        commentRequestRef.add({ content: data.comment, shop_id: this.$route.params.id, shop_name: data.shop.name, created_at: firebase.firestore.FieldValue.serverTimestamp() }).then(() => {
          data.comment = ''
          data.snackbarMsg = 'ご投稿ありがとうございます。スタッフが確認後、アプリ内に掲載させて頂きます。'
          this.$refs.error.open()
          data.hasError = false
        }).catch(() => {
          data.snackbarMsg = '投稿に失敗しました。もう一度送信ボタンを押してください。'
          this.$refs.error.open()
        })
      } else {
        data.snackbarMsg = '未入力の項目があります。'
        this.$refs.error.open()
      }
    },
    watchValue: function () {
      if (data.comment === '') {
        data.hasError = true
      } else {
        data.hasError = false
      }
    }
  },
  created () {
    db.doc(`shops/${this.$route.params.id}`).get()
    .then(function (doc) {
      if (doc.exists) {
        data.shop = doc.data()
      } else {
        router.push({name: 'NotFound'})
      }
    })
  },
  mounted () {
    data.isHidden = true
  },
  computed: {
    validation: function () {
      return { comment: !!data.comment }
    },
    isValid: function () {
      const validation = this.validation
      this.watchValue()
      return Object.keys(validation).every(key => {
        return validation[key]
      })
    }
  }
}
</script>

<style scoped>
.shop-name {
  font-size: 25px;
}
.shops-show-shop-comment {
  border: solid 1px #3CB371;
  border-radius: 10px;
  padding: 21px;
}
.shops-show-back {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Shops/Show.vue